import { User, getAuth } from "firebase/auth";
import { atom } from "jotai";

export interface AuthState {
  user: User | null;
  loading: boolean;
  error?: Error;
}

export const authStateAtom = atom<AuthState>({
  user: null,
  loading: true,
  error: undefined,
});

authStateAtom.onMount = (setAtom) => {
  const auth = getAuth();
  auth.onAuthStateChanged(
    async (user) => {
      setAtom({ user, loading: false, error: undefined });
    },
    (error) => {
      setAtom({ user: null, loading: false, error });
    },
  );
};
